import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
	NotificationModel,
	NotificationModuleKeys,
	NotificationType
} from '../../../notification-center/models/notification.model';
import {Moment} from 'moment';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {Utilities} from '@shared/utilities/utilities.model';
import { NotificationsService } from 'app/notification-center/services/notifications.service';
import { LoaderService } from '@shared/service/loader.service';
import { MessageManagerService } from '@shared/service/message-manager/message-manager.service';
import { NotificationErrorCode } from 'app/notification-center/models/notification-error-code.model';
import { MessageComponentType, MessageType } from '@shared/service/message-manager/message.model';
import {MatDialog, MatDialogRef} from '@angular/material';
import { GeneralMessageDialogComponent, GeneralMessageModel } from '../general-message-dialog/general-message-dialog.component';
import { PermissionService } from '@shared/service/permission.service';
import { NemoModuleKeys } from '@shared/models/user-permission.model';

@Component({
	selector: '[amd-notification-item]',
	templateUrl: './notification-item.component.html',
	styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent implements OnInit{

	@Input() item: NotificationModel;
	@Input() isBackOffice: boolean = false;
	@Input() showNotificationIcon: boolean = true;
	@Output() setAsRead: EventEmitter<void> = new EventEmitter<void>();
	@Output() edit: EventEmitter<void> = new EventEmitter<void>();
	@Output() getStats: EventEmitter<void> = new EventEmitter<void>();
	@Output() eventBlockNotify: EventEmitter<void> = new EventEmitter<void>();
	@Output() eventExportViews: EventEmitter<void> = new EventEmitter<void>();

	now: Moment = DateUtilities.getMoment(new Date(Date.now()));
	notificationType: typeof NotificationType = NotificationType;
	textExpired: string;
	disableNotifyViewsExport: boolean = false;
	isAld: boolean = false;

	constructor(
		private loaderService: LoaderService,
		public dialog: MatDialog,
		private notificationService: NotificationsService,
		private messageManagerService: MessageManagerService,
		private permissionService: PermissionService
	) {
	}
	ngOnInit(): void {
		this.isAld = this.profileHaveAdmin();
		//Controllo per braking news la data di scadenza per mostrarla a video
		if(this.item.type == NotificationType.BREAKING_NEWS){
			let today = new Date();
			let endDate = new Date(this.item.end_date)
			if (endDate < today) {
				this.textExpired = "SCADUTA_IL"
			}
			else{
				this.textExpired = "SCADE_IL"
			}
		}
	}

	isAfterToday(): boolean {
		return this.item.start_date && DateUtilities.getMoment(new Date(this.item.start_date)).isAfter(this.now);
	}

	isAllModules(): boolean {
		return Utilities.compareArray(this.item.metadata.modules, Object.keys(NotificationModuleKeys).map(value => NotificationModuleKeys[value]));
	}

	isBlock():boolean{
		let today = new Date();
		let endDate = new Date(this.item.end_date)
		if (endDate < today) {return true;}
		return false;
	}

	blockNotify(){
		const dialogRef: MatDialogRef<GeneralMessageDialogComponent> = this.dialog.open(GeneralMessageDialogComponent, {
			height: 'auto',
			width: '800px',
			disableClose: true
		}) as MatDialogRef<GeneralMessageDialogComponent>;
		dialogRef.componentInstance.generalMessageDialog = this.getModalSettingsForCancelNotify();
		
		dialogRef.afterClosed().subscribe(
			res => {
				if (!Utilities.isVoid(res) && res) {
					this.loaderService.display(true);
					this.notificationService.blockNotify(this.item.id).subscribe(response => {
						this.loaderService.display(false);
						if (response.ok) {
							this.eventBlockNotify.emit();
						} else {
							this.messageManagerService.pushInnerMessage({
								code: NotificationErrorCode.GENERIC_ERROR,
								type: MessageType.TYPE_ERROR,
								keepAlive: true,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					});
				}
			}
		)
	}

	exportViews(){
		//Export la lista degli utenti che hanno visualizzato la notifica se il mat-chip non è disabilitato
		if(!this.disableNotifyViewsExport){
			this.loaderService.display(true);
			this.disableNotifyViewsExport = true;
			let timeout = setTimeout(() => {
				this.disableNotifyViewsExport = false;
			}, 15000);
			this.notificationService.exportNotifyUserView(this.item.id).subscribe(
				(res) => {
					if(res.ok){
						this.messageManagerService.pushInnerMessage({
							code: NotificationErrorCode.EXPORT_AVVENUTO_CON_SUCCESSO,
							type: MessageType.TYPE_SUCCESS,
							keepAlive: true,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
					else{
						let codeError = NotificationErrorCode.GENERIC_ERROR;
						let error = res.json();
						if(error.code == "NOTIFICATION_4004"){
							codeError = error.code;
						}
						this.messageManagerService.pushInnerMessage({
							code: codeError,
							type: MessageType.TYPE_ERROR,
							keepAlive: true,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
						clearTimeout(timeout);
						this.disableNotifyViewsExport = false;
					}
					this.loaderService.display(false);
				}
			)
		}
	}

	private getModalSettingsForCancelNotify(): GeneralMessageModel{
		const msg: GeneralMessageModel = new GeneralMessageModel();
		msg.title = GeneralMessageModel.TITLE_WARNING;
		msg.txts = ["MESSAGGIO_CONFERMA_BLOCCO_NOTIZIE"];
		msg.buttons = [
			{
				txt: GeneralMessageModel.TXT_BUTTON_CANCEL,
				style: GeneralMessageModel.BUTTON_STYLE_REVERSE,
				action: false
			},
			{
				txt: GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_CONFIRM,
				style: GeneralMessageModel.BUTTON_STYLE_RAISED,
				action: true
			}
		];
		msg.showCloseButton = false;
		msg.type = GeneralMessageModel.MESSAGE_TYPE_3;

		return msg;
	}

	private profileHaveAdmin(){
		//Verifica se è presente almeno un profilo di tipo Admin
		return this.permissionService.getCurrentUserPermissions().profiles.find(p => p.type && p.type === 'ADMIN') ? true : false;
	}
}
